import React from "react";
import { useSelector } from "react-redux";
import DatePicker from "main/components/DatePicker/DatePicker";
import TimePicker from "main/components/DatePicker/TimePicker";
import DocumentView from "../DocumentView";
import ET from "../EditableText";
import TopRightTitle from "../TopRightTitle";
import { getStateFromAddress, isStateTexas } from "main/shared/helpers";
import "./style.css";

export default function ReportInspection({
  style,
  signatureDataUrl,
  signatureDate,
  signatureTime,
  onSignatureDateChange,
  onSignatureTimeChange,
  onOpenSignatureModal,
}) {
  const inspection = useSelector((state) => state.report.inspection);
  const address = useSelector(
    (state) => state.report?.cover_page?.property?.address
  );
  const addressState = getStateFromAddress(address);
  const isTexas = isStateTexas(addressState);

  return (
    <DocumentView style={style}>
      <div className="document-head">
        <header>
          <div className="grid-pg1">
            <div>
              <h3>
                <strong>
                  <ET
                    isPageTitle
                    titleKey="inspection"
                    reduxKey="inspection.title"
                    ml="50"
                  >
                    {inspection?.title}
                  </ET>
                </strong>
              </h3>
            </div>
            <div className="grid-pg1-item2">
              <TopRightTitle />
            </div>
          </div>
        </header>
      </div>
      <div className="doc-body template-body" style={{ position: "relative" }}>
        <ET reduxKey="inspection.text" ml="26000" innerHtml={true}>
          {inspection?.text}
        </ET>
        {isTexas && (
          <div className="inspection-signature-section">
            <div className="inspection-signature-field">
              <label>Date & Time</label>
              <div className="inspection-signature-datetime">
                <DatePicker
                  value={signatureDataUrl ? signatureDate : ""}
                  setValue={(value) => onSignatureDateChange?.(value)}
                  label="Date"
                  disabled={!signatureDataUrl}
                />
                <TimePicker
                  value={signatureDataUrl ? signatureTime : ""}
                  setValue={(value) => onSignatureTimeChange?.(value)}
                  label="Time"
                  disabled={!signatureDataUrl}
                />
              </div>
            </div>
            <div className="inspection-signature-field">
              <label>Assessor Consultant Signature</label>
              <div
                className="inspection-signature-preview"
                onClick={onOpenSignatureModal}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    onOpenSignatureModal?.();
                  }
                }}
              >
                {signatureDataUrl ? (
                  <img src={signatureDataUrl} alt="Signature" />
                ) : (
                  <span>Click to add signature</span>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </DocumentView>
  );
}
